<template>
  <el-form-item label="显示图例">
    <el-switch v-model="prop.legend" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="图例方向">
    <el-select v-model="prop.legendOrient" size="small">
      <el-option
          v-for="item in dicOption.orientList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
      ></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="图例位置">
    <el-select v-model="prop.legendPosition" size="small">
      <template v-if="prop.legendOrient !== 'vertical'">
        <el-option label="上方居左" value="tl"></el-option>
        <el-option label="上方居中" value="tc"></el-option>
        <el-option label="上方居右" value="tr"></el-option>
        <el-option label="下方居左" value="bl"></el-option>
        <el-option label="下方居中" value="bc"></el-option>
        <el-option label="下方居右" value="br"></el-option>
      </template>
      <template v-else>
        <el-option label="左侧居上" value="lt"></el-option>
        <el-option label="左侧居中" value="lc"></el-option>
        <el-option label="左侧居下" value="lb"></el-option>
        <el-option label="右侧居上" value="rt"></el-option>
        <el-option label="右侧居中" value="rc"></el-option>
        <el-option label="右侧居下" value="rb"></el-option>
      </template>
    </el-select>
  </el-form-item>
  <el-form-item label="图例定位">
    <div class="flex">
      <div>上：</div>
      <el-input v-model="prop.legendTop" size="small"/>
    </div>
    <div class="flex">
      <div>下：</div>
      <el-input v-model="prop.legendBottom" size="small"/>
    </div>
    <div class="flex">
      <div>左：</div>
      <el-input v-model="prop.legendLeft" size="small"/>
    </div>
    <div class="flex">
      <div>右：</div>
      <el-input v-model="prop.legendRight" size="small"/>
    </div>
  </el-form-item>
  <el-form-item label="图例排序">
    <el-select v-model="prop.legendOrder" size="small">
      <el-option label="默认" value="default"></el-option>
      <el-option label="升序" value="ascend"></el-option>
      <el-option label="降序" value="descend"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="图例标示">
    <el-select clearable v-model="prop.legendIcon" size="small">
      <el-option label="默认" value=""></el-option>
      <el-option label="圆形" value="circle"></el-option>
      <el-option label="矩形" value="rect"></el-option>
      <el-option label="圆角矩形" value="roundRect"></el-option>
      <el-option label="三角形" value="triangle"></el-option>
      <el-option label="宝石" value="diamond"></el-option>
      <el-option label="别针" value="pin"></el-option>
      <el-option label="箭头" value="arrow"></el-option>
      <el-option label="无" value="none"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="标示大小">
    <el-input-number style="width: 45%" v-model="prop.legendW" :min="0" :max="100" size="small"
                     controls-position="right"/>
    <span style="color: #fff;width: 20px;text-align: center">*</span>
    <el-input-number style="width: 45%" v-model="prop.legendH" :min="0" :max="100" size="small"
                     controls-position="right"/>
  </el-form-item>
  <el-form-item label="图例字号">
    <el-input-number v-model="prop.legendFontSize" :min="0" :max="100" size="small" controls-position="right"/>
  </el-form-item>
  <el-form-item labelAlign="left" label="图例字色">
    <colorPicker v-model="prop.legendFontColor"></colorPicker>
  </el-form-item>
  <el-form-item label="是否分页">
    <el-switch v-model="prop.isCurrent" size="small"></el-switch>
  </el-form-item>
</template>
<script setup>
import {dicOption} from "@/option/config";
import colorPicker from "./color-picker.vue";

let props = defineProps({
  prop: {},
});
</script>
<style scoped>
</style>